module.exports = __webpack_public_path__ + "img/file.5bd43cb8.svg";